import React from 'react'
import LayoutToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/LayoutToolbarSection'
import { defaultProps } from './index'

export const BannerBlockSettings = () => {
  return <LayoutToolbarSection defaultProps={defaultProps} initOpen />
}
